import { render, staticRenderFns } from "./MapFuelTanksPage.vue?vue&type=template&id=b61a0a18"
import script from "./MapFuelTanksPage.vue?vue&type=script&lang=js"
export * from "./MapFuelTanksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports